import {Action} from '@ngrx/store';

export const GET_STORE_TIMINGS = '[Stores] Get Store Timings';
export const GET_STORE_TIMINGS_SUCCESS = '[Stores] Get Store Timings Success';
export const GET_STORE_TIMINGS_ERROR = '[Stores] Get Store Timings Error';

export const ADD_NEW_TIMING = '[Stores] Add New Timing';
export const ADD_NEW_TIMING_SUCCESS = '[Stores] Add New Timing Success';
export const ADD_NEW_TIMING_ERROR = '[Stores] Add New Timing Error';

export const UPDATE_STORE_TIMINGS = '[Stores] Update Store Timings';
export const UPDATE_STORE_TIMIMGS_SUCCESS = '[Stores] Update Store Timings Success';
export const UPDATE_STORE_TIMINGS_ERROR = '[Stores] Update Store Timings Error';

export const GET_STORE_DETAILS = '[Stores] Get Store Details';
export const GET_STORE_DETAILS_SUCCESS = '[Stores] Get Store Details Success';
export const GET_STORE_DETAILS_ERROR = '[Stores] Get Store Details Error';

export const UPDATE_STORE_DETAILS = '[Stores] Update Store Details';
export const UPDATE_STORE_DETAILS_SUCCESS = '[Stores] Update Store Details Success';
export const UPDATE_STORE_DETAILS_ERROR = '[Stores] Update Store Details Error';


export class GetStoreTimings implements Action {
  readonly type = GET_STORE_TIMINGS;

  constructor(public payload: any) {
  }
}

export class GetStoreTimingsSuccess implements Action {
  readonly type = GET_STORE_TIMINGS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetStoreTimingsError implements Action {
  readonly type = GET_STORE_TIMINGS_ERROR;

  constructor(public payload: any) {
  }
}

export class AddNewTiming implements Action {
  readonly type = ADD_NEW_TIMING;

  constructor(public payload: any) {
  }
}

export class AddNewTimingSuccess implements Action {
  readonly type = ADD_NEW_TIMING_SUCCESS;

  constructor(public payload: any) {
  }
}

export class AddNewTimingError implements Action {
  readonly type = ADD_NEW_TIMING_ERROR;

  constructor(public payload: any) {
  }
}

export class GetStoreDetails implements Action {
  readonly type = GET_STORE_DETAILS;

  constructor(public payload: any) {
  }
}

export class GetStoreDetailsSuccess implements Action {
  readonly type = GET_STORE_DETAILS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetStoreDetailsError implements Action {
  readonly type = GET_STORE_DETAILS_ERROR;

  constructor(public payload: any) {
  }
}

export class UpdateStoreTimings implements Action {
  readonly type = UPDATE_STORE_TIMINGS;

  constructor(public payload: any) {
  }
}

export class UpdateStoreTimingsSuccess implements Action {
  readonly type = UPDATE_STORE_TIMIMGS_SUCCESS;

  constructor(public payload: any) {
  }
}


export class UpdateStoreTimingsError implements Action {
  readonly type = UPDATE_STORE_TIMINGS_ERROR;

  constructor(public payload: any) {
  }
}

export class UpdateStoreDetails implements Action {
  readonly type = UPDATE_STORE_DETAILS;

  constructor(public payload: any) {
  }
}

export class UpdateStoreDetailsSuccess implements Action {
  readonly type = UPDATE_STORE_DETAILS_SUCCESS;

  constructor(public payload: any) {
  }
}


export class UpdateStoreDetailsError implements Action {
  readonly type = UPDATE_STORE_DETAILS_ERROR;

  constructor(public payload: any) {
  }
}


export type SettingsAction =
  GetStoreTimings
  | GetStoreTimingsError
  | GetStoreTimingsSuccess
  | AddNewTiming
  | AddNewTimingSuccess
  | AddNewTimingError
  | GetStoreDetails
  | GetStoreDetailsSuccess
  | GetStoreDetailsError
  | UpdateStoreTimings
  | UpdateStoreTimingsSuccess
  | UpdateStoreTimingsError
  | UpdateStoreDetails
  | UpdateStoreDetailsSuccess
  | UpdateStoreDetailsError;



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/settings/store/actions/settings.action.ts